export default function MetaField({ label, value }) {
  return (
    <div className="flex flex-col gap-0.5">
      <span className="text-[16px] font-bold">{label}</span>
      <span className="text-[16px] opacity-50">{value}</span>
    </div>
  );
}
